import { render, staticRenderFns } from "./orderCollectDetail.vue?vue&type=template&id=6081c525&scoped=true&"
import script from "./orderCollectDetail.vue?vue&type=script&lang=js&"
export * from "./orderCollectDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderCollectDetail.vue?vue&type=style&index=0&id=6081c525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081c525",
  null
  
)

export default component.exports